import * as React from 'react';
import Grid from '../../components/controls/grid/Grid';
import Section from '../../components/controls/grid/Section';
import Row from '../../components/controls/grid/Row';
import Text from '../../components/controls/Text';
import { useLeapData } from '../../hooks/useLeapData';
import { useLeapState } from '../../hooks/useLeapState';

type Props = { state: any, controller: any }

export default (props: Props) => {
    const page = useLeapState(props.controller, false)

    const name = useLeapData("name", "nome permesso", page)
    const unit = useLeapData("unit", "funzione menu", page)
    const role = useLeapData("role", "ruolo", page)

    return (
        <>
            <Grid>
                <Section>
                    <Row>
                        <Text {...name} className="ms-sm12" required maxlength={50} />
                    </Row>
                    <Row>
                        <Text {...unit} className="ms-sm12" readOnly />
                    </Row>
                    <Row>
                        <Text {...role} className="ms-sm12" readOnly />
                    </Row>
                </Section>
            </Grid>
        </>
    );
}
